// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.vars.palette.grey[600]
        },
        outlined: {
          lineHeight: '1rem',
          '&.MuiInputLabel-sizeSmall': {
            lineHeight: '1em'
          },
          '&.MuiInputLabel-shrink': {
            background: theme.vars.palette.background.paper,
            padding: '0 8px',
            marginLeft: -6,
            lineHeight: '1rem'
          }
        }
      }
    }
  };
}
